module.exports = __webpack_public_path__ + "static/slide-07-0162bf1069fd7afd480a9abfc4db719d.png";